export type EventoImagen = {
	id: number;
	url: string;
	title: string;
	alt: string;
};

export type Evento = {
	id: number;
	title: string;
	description: string;
	date: string; // ISO 8601 (YYYY-MM-DD o YYYY-MM)
	color: string;
	images: EventoImagen[];
	video?: string;
};

const EventosYAcciones: Evento[] = [
	{
		id: 6,
		title: "VIDEOCLIP 'ZAMBA PARA VOLVER'",
		description: `El 18 de diciembre de 2024, con motivo del Día Internacional de las Personas Migrantes, la Asociación Equilibrio presentó el videoclip "Zamba para volver", interpretado por Adonay Santana.

Este proyecto, coordinado por la presidenta de nuestra Asociación y financiado por EQUILIBRIO, contó con la colaboración de CEAR y con la dirección audiovisual de Jared Santana.

La obra rinde homenaje a quienes se ven obligados a dejar atrás su país de origen en busca de una vida mejor. En el rodaje participaron siete jóvenes procedentes del continente africano, acompañados por CEAR, y Karol Saurith, migrante desde Colombia. Sus voces y miradas otorgan al videoclip un carácter auténtico y profundamente humano, reflejando la esperanza, la resiliencia y la fuerza de las personas migrantes.`,
		date: "2024-12-18",
		color: "azul-oscuro-corporativo",
		images: [],
		video: "https://www.youtube.com/embed/oSVU49pzG_M",
	},
	{
		id: 5,
		title:
			"TALLER: HERRAMIENTAS DIGITALES PARA OPTIMIZAR INTERVENCIONES SOCIO-EDUCATIVAS",
		description: `Nuestro compañero y amigo, Adonay Santana, trabajador social y experto en orientación laboral y competencias digitales, impartió esta teleformación de dos horas a las que acudieron profesionales del sector, quedando todas muy satisfechas con los conocimientos adquiridos. A lo largo de la formación aprendieron:

- Creación de QR Estático/Dinámico
- Uso y creación de foros como forma nueva de comunicación en las intervenciones grupales.
- Work Space (Google Drive) como herramienta de trabajo.
- Recursos pedagógicos digitales para intervenir; Línea de la vida, Padlet, Trello(plataforma), Menti Meter... Etc.
- Diseño digital de CV; Video CV, Canva, Genial.
- Técnicas de Inserción Laboral - Elevator Pitch.
- Manejo del LinkedIn`,
		date: "2021-11",
		color: "rosa-corporativo",
		images: [
			{
				id: 1,
				url: "./assets/evento-TallerHerramientasDigitales.jpeg",
				title: "Taller de Herramientas Digitales",
				alt: "Taller de Herramientas Digitales",
			},
		],
	},
	{
		id: 4,
		title:
			'TALLER "TRÁMITES PARA LA MEJORA DE LA EMPLEABILIDAD" EN EL AYTO. DE SAN MATEO',
		description: "",
		date: "2021-05-24",
		color: "azul-oscuro-corporativo",
		images: [
			{
				id: 1,
				url: "./assets/evento-TallerDeEmpleabilidad1.png",
				title: "Taller de empleabilidad",
				alt: "Taller de empleabilidad",
			},
			{
				id: 2,
				url: "./assets/evento-TallerDeEmpleabilidad2.png",
				title: "Taller de empleabilidad",
				alt: "Taller de empleabilidad",
			},
			{
				id: 3,
				url: "./assets/evento-TallerDeEmpleabilidad3.png",
				title: "Taller de empleabilidad",
				alt: "Taller de empleabilidad",
			},
			{
				id: 4,
				url: "./assets/evento-TallerDeEmpleabilidad4.png",
				title: "Taller de empleabilidad",
				alt: "Taller de empleabilidad",
			},
		],
	},
	{
		id: 3,
		title: "RECAUDACIÓN DE FONDOS – DÍA DEL LIBRO EN EL MERCADO DE SAN MATEO",
		description:
			"El 25 de abril, con motivo del día del libro, estuvimos en el Mercado de San Mateo en donde nos cedieron un puesto para recaudar fondos para la Asociación con libros de segunda mano. Fue una estupenda mañana en la que no sólo acudían a la compra de libros sino que también nos donaban. Resulta muy gratificante poder ver y disfrutar de la generosidad de la gente que por allí pasaba. A este evento acudió como voluntaria nuestra querida Karol, siempre dispuesta a todo. Logramos recaudar 135,80 € ¡¡ GRACIAS !!",
		date: "2021-04-25",
		color: "verde-corporativo",
		images: [
			{
				id: 1,
				url: "./assets/evento-DiaDelLibroSanMateo1.jpeg",
				title: "Día del libro en el Mercado de San Mateo",
				alt: "Día del libro en el Mercado de San Mateo",
			},
			{
				id: 2,
				url: "./assets/evento-DiaDelLibroSanMateo2.jpeg",
				title: "Día del libro en el Mercado de San Mateo",
				alt: "Día del libro en el Mercado de San Mateo",
			},
			{
				id: 3,
				url: "./assets/evento-DiaDelLibroSanMateo3.jpeg",
				title: "Día del libro en el Mercado de San Mateo",
				alt: "Día del libro en el Mercado de San Mateo",
			},
			{
				id: 4,
				url: "./assets/evento-DiaDelLibroSanMateo4.png",
				title: "Día del libro en el Mercado de San Mateo",
				alt: "Día del libro en el Mercado de San Mateo",
			},
		],
	},
	{
		id: 2,
		title: "RECAUDACIÓN DE FONDOS – TALLER DE ACROYOGA EN LAS CANTERAS",
		description:
			"Este día tuvimos el placer de contar con la colaboración de @malina_palina y @jan.tabakafitness.dance para la realización de un divertido taller de acroyoga en la playa de Las Canteras con el fin de recaudar fondos para la Asociación. Todo lo aportado fue destinado a la misma. Fue un encuentro muy agradable que esperamos volver a repetir. Durante la jornada logramos recaudar 94.40 € ¡GRACIAS!",
		date: "2021-03-13",
		color: "ocre-corporativo",
		images: [],
		video: "/assets/taller-acroyoga.mp4",
	},
	{
		id: 1,
		title:
			"REUNIÓN CON NOEMÍ SANTANA, DIPUTADA DEL PARLAMENTO DE CANARIAS Y CONSEJERA DE DERECHOS SOCIALES, IGUALDAD, DIVERSIDAD Y JUVENTUD DEL GOBIERNO DE CANARIAS.",
		description:
			"El equipo de la Asociación Equilibrio, con el fin de difundir los objetivos perseguidos y solicitar apoyo a las administraciones públicas, se reúne con Noemí Santana, quién nos atendió y escuchó con una implicación exquisita.",
		date: "2021-02-17",
		color: "rosa-corporativo",
		images: [
			{
				id: 1,
				url: "/assets/evento-ReunionNoemiSantana1.jpeg",
				title: "Reunión con Noemí Santana",
				alt: "Reunión con Noemí Santana",
			},
			{
				id: 2,
				url: "/assets/evento-ReunionNoemiSantana2.jpeg",
				title: "Reunión con Noemí Santana",
				alt: "Reunión con Noemí Santana",
			},
		],
	},
];

export default EventosYAcciones;
